import { ComponentType } from 'react';

import CreateWorkspaceDataProvider from './CreateWorkspaceDataProvider';
import { CreateWorkspaceInitOptions } from '../types';

const withCreateWorkspaceDataProvider = <P extends object>(Component: ComponentType<P>) => {
  const WrappedComponent = (props: P & CreateWorkspaceInitOptions) => {
    const { parentWorkspaceId, initialStep, initialWorkspaceId, mode, ...restProps } = props;

    return (
      <CreateWorkspaceDataProvider
        parentWorkspaceId={parentWorkspaceId}
        initialStep={initialStep}
        initialWorkspaceId={initialWorkspaceId}
        mode={mode}
      >
        <Component {...(restProps as P)} />
      </CreateWorkspaceDataProvider>
    );
  };

  WrappedComponent.displayName = `withCreateWorkspaceDataProvider(${Component.displayName || Component.name})`;

  return WrappedComponent;
};

export default withCreateWorkspaceDataProvider;
